export interface RestoreAttempt { operationId: string; snapshotId: string; fingerprint: string | null; stage: 'review' | 'submitted'; intent?: 'restore' | 'abandon' }
const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export function readRestoreAttempt(key: string): RestoreAttempt | null {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  const value = JSON.parse(raw);
  if (!value || !uuid.test(value.operationId) || !uuid.test(value.snapshotId) || !['review', 'submitted'].includes(value.stage) || (value.intent !== undefined && !['restore', 'abandon'].includes(value.intent)) || !(value.fingerprint === null || typeof value.fingerprint === 'string')) throw new Error('Invalid restore recovery record');
  return value;
}
export function writeRestoreAttempt(key: string, value: RestoreAttempt | null) {
  if (value) localStorage.setItem(key, JSON.stringify(value));
  else localStorage.removeItem(key);
}
